export const EDIT_PROFILE = "EDIT_PROFILE"
export const PROFILE_SUCCESS = "PROFILE_SUCCESS"
export const PROFILE_ERROR = "PROFILE_ERROR"
export const RESET_PROFILE_FLAG = "RESET_PROFILE_FLAG";

export const RESET_CHANGE_PROFILE_PICTURE = "RESET_CHANGE_PROFILE_PICTURE"
export const CHANGE_PROFILE_PICTURE = "CHANGE_PROFILE_PICTURE"
export const CHANGE_PROFILE_PICTURE_SUCCESS = "CHANGE_PROFILE_PICTURE_SUCCESS"
export const CHANGE_PROFILE_PICTURE_FAILED = "CHANGE_PASSWORD_FAILED"